export default {

  mainContainer: {
    background: 'white'
  },

  mainButton: {
    paddingRight: 25,
    paddingLeft: 25
  },

  shoppingMethodButton: {
    alignSelf: 'flex-end'
  },

  shoppingMethodButtonWithMargin: {
    alignSelf: 'flex-end',
    paddingRight: '10px'
  },

  dropdownContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },

  dropdownOuterContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '5px',
    width: '100%'
  },

  /**
   * @usecase
   * ButtonMaker divStyle
   */
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 10
  },

  flexCenterDropDown: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 5,
    paddingBottom: 5
  },

  dropDownStyle: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    paddingTop: 10,
    paddingLeft: '10px'
  },

  dropDownStyling: {
    width: '29%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '1%',
    paddingRight: '1%'
  },
  dropdownSpacing: {
    width: '100%',
    height: '40px',
    fontSize: '13px',
    maxWidth: '250px'
  },

  /**
   * usage:
   * brandlist
   */
  containerHeader: {
    fontSize: 20,
    textAlign: 'center',
    marginTop: '20px'
  },

  btn__main1: {
    color: 'white',
    backgroundColor: '#C50000',
    borderRadius: '0px',
    border: '0px',
    fontSize: '10px',
    width: '100px'
  },

  btn__main2: {
    color: 'white',
    backgroundColor: '#C50000',
    borderRadius: '0px',
    border: '0px',
    marginTop: '20px',
    fontSize: '10px',
    width: '150px'
  },

  btn__main3: {
    color: 'white',
    backgroundColor: '#C50000',
    borderRadius: '0px',
    border: '0px',
    fontSize: '10px',
    width: '150px',
    marginBottom: '15px',
    marginLeft: '15px'
  }
};



// WEBPACK FOOTER //
// ./src/statics/styles.js